import { useSwitchToCreatedIdol } from '@/hooks/useSwitchToCreatedIdol';

import MainNav from '@/components/layout/AppNavbar';
import NickName from '@/features/auth/components/IdolNickname';


function IdolCreate() {
    const switchToCreatedIdol = useSwitchToCreatedIdol();

    return (
        <>
            <MainNav />
            <main className="container-lg nav-padding">
                <div className="idol-create mx-auto mt-4 border rounded shadowA bg-white">
                    <NickName onResponse={ switchToCreatedIdol }/>
                </div>
            </main>
        </>
    );
}

export default IdolCreate;
